/**
 * @license
 * Copyright 2017 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { TypedReducerBuilderImpl } from "./internal/TypedReducerBuilderImpl";
/**
 * Important utility to help build Redux Reducer functions
 * when you have TypedActions available. In contrast to normal
 * reducer writing, the TypedReducer gives strong type inferencing
 * in each of your Action type branches.
 */
export var TypedReducer;
(function (TypedReducer) {
    /**
     * Returns a new instance of a TypedReducer.Builder.
     */
    function builder() {
        return new TypedReducerBuilderImpl();
    }
    TypedReducer.builder = builder;
})(TypedReducer || (TypedReducer = {}));
